import { render } from "./AddressEntryDetailModal.vue?vue&type=template&id=3a10c8ef&scoped=true"
import script from "./AddressEntryDetailModal.vue?vue&type=script&lang=js"
export * from "./AddressEntryDetailModal.vue?vue&type=script&lang=js"

import "./AddressEntryDetailModal.vue?vue&type=style&index=0&id=3a10c8ef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a10c8ef"]])

export default __exports__